import React, { useEffect, useState } from "react";
import UserWrapper from "./Fax.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import FaxForm from "components/Fax/FaxForm";

const FaxEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const hasParam = props.match.params.id;

  useEffect(() => {
    if (hasParam) {
      setEditedData(props.location.state);
    }
  }, []);

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.fax"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.fax",
              url: "/fax"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/fax")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"} Fax
              Number
            </div>
          </div>
          <div className="roe-card-body">
            <FaxForm
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
              history={props.history}
              {...props}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer
  };
};

export default connect(mapStateToProps, null)(FaxEdit);
